CalendarSettingsView = require 'app/scripts/views/power-ups/calendar-settings-view'
CardAgingSettingsView = require 'app/scripts/views/power-ups/card-aging-settings-view'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
VotingSettingsView = require 'app/scripts/views/power-ups/voting-settings-view'

module.exports = [
  name: 'voting'
  settingsView: (model) -> new VotingSettingsView({ model })
  id: LegacyPowerUps.voting
,
  name: 'cardAging'
  settingsView: (model) -> new CardAgingSettingsView({ model })
  id: LegacyPowerUps.cardAging
,
  name: 'calendar'
  settingsView: (model) -> new CalendarSettingsView({ model })
  id: LegacyPowerUps.calendar
]
